<template>
    <b-modal v-model="show" title="ПАРАМЕТЕР" size="lg" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-md-8">
                    <div class="form-group">
                        <label>Вилоят <span class="red">*</span></label>
                        <v-select v-model="data.province"
                                  label="name"
                                  :options="provinces"
                                  :filterable="false"
                                  @search="onProvinceSearch"
                                  @search:focus="onProvinceFocus"
                                  :class="{invalid: $v.data.province.$error}"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                    <div class="form-group">
                        <label>Референс <span class="red">*</span></label>
                        <v-select
                            v-model="data.coefficientField"
                            label="name"
                            :options="references"
                            :filterable="false"
                            :class="{invalid: $v.data.coefficientField.$error}"
                            @search="onCoefficientFieldSearch"
                            @search:focus="onCoefficientFieldFocus"
                            @change="onChange"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label>Майдонлар </label>
                        <div class="table-responsive">
                            <div class="table-wrapper">
                              <table class="table table-striped" style="min-width: 700px;">
                                  <thead>
                                  <tr>
                                      <th width="5%">#</th>
                                      <th width="70%">Текст</th>
                                      <th width="30%">Қиймат</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <template v-if="resultFields && resultFields.length > 0">
                                      <tr v-for="(field,index) in resultFields" :key="index">
                                          <td>{{index + 1}}</td>
                                          <td>{{field.name}}</td>
                                          <td>
                                              <numeric-input v-model="field.value" :precision="2" />
                                          </td>
                                      </tr>
                                  </template>
                                  </tbody>
                              </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import initFilterModel from '@/shared/filter';
    import {clone} from '@/shared/utils';
    import { required } from 'vuelidate/lib/validators'

    export default {
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                data: this.initEmptyData(),
                provinces: [],
                provinceFilter: initFilterModel(),
                referenceFilter: initFilterModel(),
                references: [],
                fields: [],
                resultFields: []
            }
        },
        validations() {
            return {
                data: {
                    province: {
                        id: {
                            required: required
                        }
                    },
                    coefficientField: {
                        id: {
                            required: required
                        }
                    }
                }
            }
        },
        methods: {
            initEmptyData() {
                return {
                    province: null,
                    coefficientField: null
                }
            },
            save() {
                console.log(this.data);
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                const vm = this;
                this.data.data = {};
                if (this.resultFields && this.resultFields.length > 0) {
                    this.data.data.fields = this.resultFields.filter((field) => {
                        return field.code && field.code.length > 0 && field.name && field.name.length > 0
                    });
                } else {
                    return;
                }
                this.$http.post('real-estate/employment/coefficient',this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('employmentCoefficientChange', response);
                        }
                    },err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            cancel() {
                this.show = false;
            },
            onProvinceSearch(searchTxt,loading) {
                loading(true);
                this.provinces = [];
                this.provinceFilter.search = searchTxt;
                this.$http.post('/province/search',this.provinceFilter)
                    .then(res => {
                        const response = res.data;
                        this.provinces = response.data;
                        loading(false)
                    },err => {
                        console.log(err)
                    });
            },
            onProvinceFocus() {
                this.provinces = [];
                this.provinceFilter.search = '';
                this.$http.post('/province/search',this.provinceFilter)
                    .then(res => {
                        const response = res.data;
                        this.provinces = response.data;
                    },err => {
                        console.log(err)
                    });
            },
            onCoefficientFieldSearch(searchTxt,loading) {
                loading(true);
                this.references = [];
                this.referenceFilter.search = searchTxt;
                this.referenceFilter.parentOnly = true;
                this.referenceFilter.parentCode = null;
                this.$http.post('real-estate/employment/coefficient/field/list',this.referenceFilter)
                    .then(res => {
                        const response = res.data;
                        this.references = response.data;
                        loading(false)
                    },err => {
                        console.log(err)
                    });
            },
            onCoefficientFieldFocus() {
                this.references = [];
                this.referenceFilter.search = '';
                this.referenceFilter.parentOnly = true;
                this.referenceFilter.parentCode = null;
                this.$http.post('real-estate/employment/coefficient/field/list',this.referenceFilter)
                    .then(res => {
                        const response = res.data;
                        this.references = response.data;
                    },err => {
                        console.log(err)
                    });
            },
            onChange() {
                if (this.data.coefficientField) {
                    this.resultFields = [];
                    this.fields = [];
                    this.referenceFilter.parentCode = this.data.coefficientField.code;
                    this.referenceFilter.parentOnly = false;
                    this.$http.post('real-estate/employment/coefficient/field/list',this.referenceFilter)
                        .then(res => {
                            const response = res.data;
                            this.fields = response.data;
                            if (this.fields && this.fields.length > 0) {
                                this.fields.forEach((field) => {
                                    if (this.data.data && this.data.data.fields && this.data.data.fields.length > 0) {
                                        let resultField = this.data.data.fields.find(f => f.code === field.code);
                                        if (resultField) {
                                            this.resultFields.push(resultField);
                                        } else {
                                            this.addField(field);
                                        }
                                    } else {
                                        this.addField(field);
                                    }
                                });
                            }
                        },err => {
                            console.log(err)
                        });
                } else {
                    this.resultFields = [];
                }
            },
            addField(field) {
                this.resultFields.push({
                    code: field.code,
                    name: field.name,
                    value: null
                });
            }
        },
        created() {
            this.provinceFilter.page.size = 20;
            this.referenceFilter.page.size = 1000;
            this.$eventBus.$on('showEmploymentCoefficientModal', (data) => {
                if (data) {
                    this.data = clone(data);
                    console.log('data = ',this.data)
                } else {
                    this.resultFields = [];
                    this.data = this.initEmptyData();
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>